import React from "react";

export default function AJImg(props) {
    const alt = props.alt || 'genvalues'

    return <img {...props} alt={alt}/>
}